import React from 'react';
import { NavLink } from 'react-router-dom';
import { t, useUiLang } from '../utils/lang.js';

const Icon = ({ name }) => (
  <span className="icon" aria-hidden>
    {name === 'home' && (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M3 10L12 3l9 7v10a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1V10z" stroke="currentColor" strokeWidth="1.5"/></svg>
    )}
    {name === 'book' && (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M4 4h11a3 3 0 0 1 3 3v12H7a3 3 0 0 0-3 3V4z" stroke="currentColor" strokeWidth="1.5"/></svg>
    )}
    {name === 'bookmark' && (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M6 4h12v17l-6-3-6 3V4z" stroke="currentColor" strokeWidth="1.5"/></svg>
    )}
    {name === 'settings' && (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" stroke="currentColor" strokeWidth="1.5"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06A1.65 1.65 0 0 0 15 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 8.6 15a1.65 1.65 0 0 0-1.82-.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 8.6a1.65 1.65 0 0 0-.33-1.82l-.06-.06A2 2 0 1 1 7.04 3.9l.06.06A1.65 1.65 0 0 0 8.6 4.6c.5 0 1-.2 1.36-.56l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06c-.36.36-.56.86-.56 1.36 0 .5.2 1 .56 1.36l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06c-.36-.36-.86-.56-1.36-.56-.5 0-1 .2-1.36.56l-.06.06A2 2 0 1 1 3.9 16.96l.06-.06c.36-.36.56-.86.56-1.36 0-.5-.2-1-.56-1.36l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06c.36.36.86.56 1.36.56.5 0 1-.2 1.36-.56l.06-.06A2 2 0 1 1 16.96 3.9l-.06.06c-.36.36-.56.86-.56 1.36 0 .5.2 1 .56 1.36l.06.06c.36.36.56.86.56 1.36 0 .5-.2 1-.56 1.36l-.06.06c-.36.36-.56.86-.56 1.36 0 .5.2 1 .56 1.36l.06.06z" stroke="currentColor" strokeWidth="1.5"/></svg>
    )}
  </span>
);

export const TabBar = () => {
  useUiLang();
  return (
    <nav className="tabbar">
      <NavLink to="/" className={({isActive}) => 'tabbar__item' + (isActive ? ' active' : '')}>
        <Icon name="home"/>
        <span>{t('tab_home')}</span>
      </NavLink>
      <NavLink to="/surahs" className={({isActive}) => 'tabbar__item' + (isActive ? ' active' : '')}>
        <Icon name="book"/>
        <span>{t('tab_quran')}</span>
      </NavLink>
      <NavLink to="/bookmarks" className={({isActive}) => 'tabbar__item' + (isActive ? ' active' : '')}>
        <Icon name="bookmark"/>
        <span>{t('tab_bookmarks')}</span>
      </NavLink>
      <NavLink to="/settings" className={({isActive}) => 'tabbar__item' + (isActive ? ' active' : '')}>
        <Icon name="settings"/>
        <span>{t('tab_settings')}</span>
      </NavLink>
    </nav>
  );
};
